import MatestackUiVueJs from "matestack-ui-vuejs";

// Sidecar for Web::Components::Toast. Listens on the Matestack event hub
// for the notice and failure events, and on every event replaces the message
// and restarts the timer, so a second event inside the window never keeps the
// first one's text. An event without a message leaves the toast as it is.
const NOTICE_MS = 4000;
const FAILURE_MS = 6000;

const toast = {
  mixins: [MatestackUiVueJs.componentMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,
  data() {
    return { message: "", kind: "notice", timer: null };
  },
  created() {
    this.handlers = [];
    this.listen(this.props["notice_events"], "notice", NOTICE_MS);
    this.listen(this.props["failure_events"], "error", FAILURE_MS);
  },
  beforeUnmount() {
    clearTimeout(this.timer);
    this.handlers.forEach(([name, handler]) => MatestackUiVueJs.eventHub.$off(name, handler));
  },
  methods: {
    listen(names, kind, ms) {
      String(names || "")
        .split(",")
        .map((n) => n.trim())
        .filter(Boolean)
        .forEach((name) => {
          const handler = (data) => this.show(data, kind, ms);
          MatestackUiVueJs.eventHub.$on(name, handler);
          this.handlers.push([name, handler]);
        });
    },
    show(data, kind, ms) {
      // A failure with no message (a server error page) still says something.
      const message = (data && data.message) || (kind === "error" ? "That didn't save. Try again, and if it keeps failing, tell Keith." : "");
      if (!message) return;
      clearTimeout(this.timer);
      this.kind = kind;
      this.message = message;
      this.timer = setTimeout(() => (this.message = ""), ms);
    },
  },
};

export default toast;
